<template>
  <div class="TuanPay">
    <div class="orderp-form">
      <van-cell-group class="no-border no-back">
        <van-field
          label="姓名"
          placeholder="请输入姓名"
          type="text"
          v-model="form.realname"
        ></van-field>
      </van-cell-group>
      <van-cell-group class="no-border no-back">
        <van-field
          label="手机"
          placeholder="请输入手机号"
          type="text"
          v-model="form.mobile"
        ></van-field>
      </van-cell-group>
      <van-cell-group class="no-border no-back flex-centers">
        <van-field
          placeholder="请输入车牌号"
          type="text"
          v-model="form.carNo"
          label-width="auto"
        >
          <div slot="label" class="flex-area">
            <span class="text-bold">车牌号</span>
            <span class="arrow-area" @click="showArea = true">
              <i class="text">{{ areaText || "选择" }}</i>
              <van-icon name="arrow-down" />
            </span>
            <span class="arrow-area" @click="showNo = true">
              <i class="text">{{ areaNo || "选择" }}</i>
              <van-icon name="arrow-down" />
            </span>
          </div>
        </van-field>
      </van-cell-group>
      <!-- 自定义字段 -->
      <van-cell-group
        class="no-border no-back"
        v-for="(v, index) in fieldList"
        :key="index"
      >
        <van-field
          :label="v.val"
          :placeholder="`请输入${v.val}`"
          type="text"
          v-model="form[v.id]"
        ></van-field>
      </van-cell-group>
      <!-- <van-cell-group class="no-border no-back">
        <van-field label="车品牌" placeholder="请输入车品牌" type="text" v-model="form.carBrand"></van-field>
      </van-cell-group>-->
      <!-- 自定义字段 -->
      <van-cell-group class="no-border no-back">
        <van-field
          label="预约门店"
          readonly
          :disabled="shopStatus"
          type="text"
          v-model="store.shopName"
          is-link
          class="blueselect"
          @click="goStore"
        ></van-field>
      </van-cell-group>
    </div>
    <div class="fixed">
      <div class="flexbox">
        <!-- <div class="msg">
          应支付
          <span class="price">¥{{theItem.priceAct|formatMoney}}</span>
        </div>-->
        <van-button type="primary" class="orange-fault flex-1" @click="toPay()"
          >确认订单</van-button
        >
      </div>
    </div>
    <!-- 车牌区域 -->
    <van-popup v-model="showArea" position="bottom" :style="{ height: '50%' }">
      <div class="area-code">
        <van-button
          @click="getAreaText(v)"
          v-for="v in carData"
          :key="v"
          type="default"
          >{{ v }}</van-button
        >
      </div>
    </van-popup>
    <!-- 车牌字母 -->
    <van-popup v-model="showNo" position="bottom" :style="{ height: '50%' }">
      <div class="area-code">
        <van-button
          @click="getAreaNo(v)"
          v-for="v in carNo"
          :key="v"
          type="default"
          >{{ v }}</van-button
        >
      </div>
    </van-popup>
  </div>
</template>
<script>
// import timeCounterSinple from '@/components/timeCounterSinple';
import { mPattern, carParttern } from "@/assets/js/rules";
import { carTitle, carNum, carFirstTitle } from "@/api/carData";
export default {
  name: "TuanSuccess",
  components: {},
  data () {
    return {
      form: {
        realname: "", // 姓名
        mobile: "", // 手机号
        carNo: "", // 车牌号
        store: 6 // 预约门店
      },
      areaText: "",
      areaNo: "",
      shopStatus: false, // 选择门店
      showArea: false, // 弹窗
      showNo: false, // 弹窗
      carData: Array.from(carTitle),
      carNo: Array.from(carNum),
      carFirstTitle,
      show: false,
      wx: 1,
      // 活动用户自定义字段
      fieldList: [],
      store: {
        shopName: ""
      },
      backNo: ""
    };
  },
  watch: {
    // store(t) {
    //   this.form.store = t.id;
    // }
    "form.carNo" (t) {
      console.log(t);
      if (this.backNo === t) {
        return;
      }
      if (t) {
        this.form.carNo = t.toUpperCase();
        this.backNo = t;
      }
    }
  },
  computed: {},
  created () { },
  async mounted () {
    this.removeStore('payMsg');
    this.removeStore('aId');
    if (this.getStore('addrObj') && this.getStore('addrObj').province !== '') {
      let province = this.getStore('addrObj').province;
      carFirstTitle.filter(it => {
        if (it.name === province) {
          this.areaText = it.title;
        }
      });
    }
    console.log("mounted", this.$route.query);
    this.shopStatus = false;
    this.store = this.getStore("selectedStore") || {};
    console.log(this.store);
    if (this.getStore("shopInfo") && this.getStore("shopInfo") !== "") {
      this.shopStatus = true;
      this.store = this.getStore("shopInfo");
      this.setStore("selectedStore", this.getStore("shopInfo"));
    }
    if (!this.store.hasOwnProperty("id") && !this.getStore("shopInfo")) {
      await this.getList();
    }
    // console.log(this.store);

    await this.getDetail();
    let form = JSON.parse(localStorage.getItem("form"));
    if (form) {
      this.areaText = form.carNoStr[0];
      this.areaNo = form.carNoStr[1];
      this.form = { ...form };
    } else {
      let res = this.isWechat && (await this.getUserInfo());
      console.log(res);
      if (res) {
        this.form = {
          realname: res.data.realname, // 姓名
          mobile: res.data.mobile // 手机号
        };
        if (res.data.userCarList.length > 0) {
          this.$set(this.form, "carNo", res.data.userCarList[0].carNo.substr(2));
          // this.form.carNo = res.data.userCarList[0].carNo.substr(2);
          this.areaText = res.data.userCarList[0].carNo[0];
          this.areaNo = res.data.userCarList[0].carNo[1];
        }
      }
    }
    console.log('this.$route.query.mobile', this.$route.query.mobile, this.form);
    if (this.$route.query.mobile) {
      this.form.userPhone = this.$route.query.mobile;
      this.form.mobile = this.$route.query.mobile;
    }
  },
  methods: {
    // 获取参与活动的门店列表  如果是单门店 就自动选择
    async getList () {
      // activity/activityShop/list
      let query = this.getQuery(this);
      // this.setStore('lbsLongitude', 120.024487);
      // this.setStore('lbsLatitude', 30.279454);
      let result = await this.request("/activity/activityShop/list", {
        activityId: query.id,
        lbsLongitude: this.getStore("lbsLongitude") || '',
        lbsLatitude: this.getStore("lbsLatitude") || '',
        shopType: "", // 门店类型id
        shopLevel: "", // 等级id
        shopServiceId: "", // 服务id
        district: "", // 区
        orderType: "" /// /1距离 离我最近 2 好评
      });
      console.log(result, 'rassadasdasd');
      if (result) {
        this.store = result.List[0];
        this.setStore("selectedStore", result.List[0]);
        if (localStorage.getItem('isShareShop') && localStorage.getItem('isShareShop') !== '') {
          console.log(localStorage.getItem('isShareShop'));
          result.List.filter((it, index) => {
            if (Number(it.id) === Number(localStorage.getItem('isShareShop'))) {
              this.store = result.List[index];
              this.setStore("selectedStore", result.List[index]);
            }
          });
          localStorage.removeItem('isShareShop');
        }
        // if (result.List.length === 1) {
        //   this.store = result.List[0];
        //   this.setStore("selectedStore", result.List[0]);
        //   // this.setStore("areaSelect", result.data[0].district);
        //   // this.setStore("citySelect", result.data[0].city);
        // }
      }
    },
    // 获取区域车牌
    getAreaText (v) {
      this.areaText = v;
      this.showArea = false;
    },
    // 获取车牌字母
    getAreaNo (v) {
      this.areaNo = v;
      this.showNo = false;
    },
    async getJoinTeam () {
      try {
        this.loading = true;
        // activity/activity/getUserField
      } catch (e) {
        this.$error(e.message);
      }
    },
    // 获取用户默认信息
    async getUserInfo () {
      return this.request("/user/user/get", {});
    },
    // store
    goStore () {
      if (this.res.way === 2) {
        return;
      }
      let param = { ...this.form };
      param.carNoStr =
        (this.areaText ? this.areaText : "") +
        (this.areaNo ? this.areaNo : "") +
        (param.carNo ? param.carNo : "");
      param.id = this.$route.query.id;
      param.store = this.store;

      localStorage.setItem("form", JSON.stringify(param));
      // this.go(`/store?select=${1}&id=${this.res.id}&new=1`);
      this.go(`/store?select=${1}&id=${this.res.id}`);
    },
    // store
    // 提交表单
    toPay () {
      console.log("pay", this.$route.query);
      if (this.testParam(this.form)) {
        // if (this.$route.query.buyLimit <= this.$route.query.saleNum) {
        //   this.$error("抢完了，期待更多精彩活动吧~");
        //   setTimeout(() => {
        //     this.goBack();
        //   }, 1000);
        //   return;
        // }
        let param = { ...this.form };
        if (this.$route.query.mobile && this.$route.query.mobile !== "") {
          param.userPhone = this.$route.query.mobile;
        }
        param.carNoStr = this.areaText + this.areaNo + param.carNo;
        param.id = this.$route.query.id;
        param.store = this.store;

        localStorage.setItem("form", JSON.stringify(param));
        let url = `/Activity/OrderCheck?id=${param.id}&type=${this.$route.query.type || ''}`;
        if (this.$route.query.parentId) {
          url = `/Activity/OrderCheck?id=${param.id}&parentId=${this.$route.query.parentId}`;
        }
        this.go(url);
      }
    },
    // 验证表单
    testParam (param) {
      let carNo = this.areaText + this.areaNo + param.carNo;
      if (!param.realname) {
        this.$error("请输入姓名");
        return false;
      } else if (!param.mobile) {
        this.$error("请输入手机号");
        return false;
      } else if (!mPattern.test(param.mobile)) {
        this.$error("手机号格式有误");
        return false;
      } else if (!param.carNo) {
        this.$error("请输入车牌号");
        return false;
      } else if (!carParttern.test(carNo)) {
        this.$error("车牌号格式错误");
        return false;
      } else if (!this.store.hasOwnProperty("id")) {
        this.$error("请选择预约门店");
        return false;
      }
      let flag = true;
      this.fieldList.forEach((it) => {
        if (!param[it.id] && flag) {
          this.$error(`请输入${it.val}`);
          flag = false;
        }
      });
      if (!flag) {
        return flag;
      } else {
        return true;
      }
    },
    // 活动自定义字段
    async getDetail () {
      let query = this.getQuery(this);
      let list = await this.getUserField(query.id);
      // console.log(list);
      let userFieldList = await this.getUserFieldList();
      // console.log(userFieldList);
      let newList = userFieldList.filter((it) => {
        let flag = false;
        // 选一遍符合活动的
        list.forEach((ele) => {
          if (ele.id === it.id) {
            flag = true;
          }
        });
        // 去除固定的
        if (it.id === "realname" || it.id === "mobile" || it.id === "carNo") {
          flag = false;
        }
        return flag;
      });
      // console.log(newList);
      this.fieldList = newList;

      let result = await this.request("/activity/activity/userActivityGet", {
        id: query.id
      });
      if (result.code === 0) {
        this.res = {
          ...result.data,
          originalPrice: result.data.originalPrice / 100,
          price: result.data.price / 100,
          endTimeStemp:
            this.toTimeStamp(result.data.endTime) - new Date().getTime(),
          timeStr:
            this.dateFormat(
              this.toTimeStamp(result.data.startTime),
              "yyyy年MM月dd日"
            ) +
            "-" +
            this.dateFormat(this.toTimeStamp(result.data.endTime), "MM月dd日"),
          dateNum: Math.round(
            (this.toTimeStamp(result.data.endTime) -
              this.toTimeStamp(result.data.startTime)) /
            86400000
          ),
          imgsArr: result.data.imgs.split(",")
        };
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import "~@/assets/css/style";
.TuanPay {
  // background: #f7f7f7;
  // height: 100vh;
  overflow: auto;
  box-sizing: border-box;
  padding-bottom: 73px;
  .paymsg {
    align-items: flex-end;
    h4 {
      font-size: 15px;
      font-weight: bold;
      margin-bottom: 15px;
    }
    .label {
      font-size: 14px;
      color: #333;
    }
  }
  .price {
    color: #ff8939;
    margin-left: 10px;
    font-size: 15px;
  }
  .fixed {
    position: fixed;
    left: 0;
    bottom: 0;
    right: 0;
    height: 72px;
    background: #fff;
    border-top: 1px solid rgba(238, 238, 238, 1);
    .flexbox {
      height: 100%;
      padding: 0 15px;
      display: flex;
      align-items: center;
      .msg {
        font-size: 12px;
        color: #999999;
        flex: 1;
      }
    }
  }
  .flex-centers {
    .flex-center();
    .flex-area {
      .flex-center();
      justify-content: flex-start;
      white-space: nowrap;
      .text-bold {
        padding-right: 10px;
      }
      .arrow-area {
        margin-right: 10px;
        .flex-center();
        i {
          color: #3296fa;
          font-size: 13px;
          &.van-icon {
            font-size: 12px;
          }
        }
        .text {
          padding-right: 2px;
          font-style: normal;
        }
      }
    }
  }
  .area-code {
    display: flex;
    flex-wrap: wrap;
    margin: 2.5%/2;
    .van-button {
      min-width: 10%;
      max-width: 10%;
      margin: 2.5%/2;
      padding: 0;
      line-height: 1;
      flex: 1;
    }
  }
}
</style>